(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NatucoposPricingCoreV21 = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var TIERS = [1000, 2000, 5000, 10000];

  function toCents(value) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number' && Number.isFinite(value)) return Math.round(value * 100);
    var text = String(value).trim().replace(/R\$/gi, '').replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
    if (!text) return null;
    if (text.indexOf(',') > -1 && text.indexOf('.') > -1) text = text.replace(/\./g, '').replace(',', '.');
    else if (text.indexOf(',') > -1) text = text.replace(',', '.');
    var number = Number(text);
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function normalizeMoneyToCents(value) {
    var normalized = toCents(value);
    return Number.isInteger(normalized) && normalized > 0 ? normalized : null;
  }

  function normalizeStoredCents(value) {
    if (value === null || value === undefined || value === '') return null;
    var normalized = Number(value);
    return Number.isFinite(normalized) && normalized > 0 ? Math.round(normalized) : null;
  }

  function firstDefined(primary, fallback) {
    return primary !== null && primary !== undefined ? primary : fallback;
  }

  function normalizeProductPricing(pricing) {
    pricing = pricing || {};
    if (pricing.tiers && typeof pricing.tiers === 'object') {
      var tiers = {};
      TIERS.forEach(function (tier) {
        var value = pricing.tiers[String(tier)];
        tiers[String(tier)] = Number.isSafeInteger(value) && value > 0 ? value : null;
      });
      return { active: pricing.active === true, sku: String(pricing.sku || '').trim().toUpperCase(), updatedAt: pricing.updatedAt || null, tiers: tiers };
    }
    return {
      active: pricing.active === true || String(pricing.active).toLowerCase() === 'true',
      sku: String(pricing.idProduct || pricing.sku || '').trim().toUpperCase(),
      updatedAt: pricing.updatedAt || null,
      tiers: {
        '1000': normalizeMoneyToCents(firstDefined(pricing.p1000, pricing['1000'])),
        '2000': normalizeMoneyToCents(firstDefined(pricing.p2000, pricing['2000'])),
        '5000': normalizeMoneyToCents(firstDefined(pricing.p5000, pricing['5000'])),
        '10000': normalizeMoneyToCents(firstDefined(pricing.p10000, pricing['10000'])),
      },
    };
  }

  function signatureFromBook(book) {
    book = book || {};
    return TIERS.map(function (tier) {
      var value = normalizeStoredCents(book[String(tier)]);
      return value === null ? '-' : String(value);
    }).join('|');
  }

  function completeBook(book) {
    book = book || {};
    return TIERS.every(function (tier) {
      return normalizeStoredCents(book[String(tier)]) !== null;
    });
  }

  function completeProductSignature(product) {
    return !!product && completeBook(product.tiers);
  }

  function automationSafeRow(data, row) {
    if (!row || row.blocked) return false;
    if ((data && data.highAnomalyRows || []).indexOf(row.id) > -1) return false;
    return completeBook(row.br) && completeBook(row.go);
  }

  function integrityPayload(data) {
    var rows = data && data.rowsById ? data.rowsById : {};
    return Object.keys(rows).sort().map(function (rowId) {
      var row = rows[rowId];
      return [row.id, signatureFromBook(row.br), signatureFromBook(row.go), row.blocked ? '1' : '0'].join('|');
    }).join(';');
  }

  function fnv1a32(text) {
    var hash = 0x811c9dc5;
    for (var i = 0; i < text.length; i += 1) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return ('00000000' + hash.toString(16)).slice(-8);
  }

  function validateData(data) {
    var errors = [];
    if (!data || typeof data !== 'object') return { ok: false, errors: ['DATA_MISSING'] };
    var rows = data.rowsById || {};
    var rowIds = Object.keys(rows);
    if (rowIds.length !== 173) errors.push('ROW_COUNT_' + rowIds.length);
    var seen = Object.create(null);
    rowIds.forEach(function (rowId) {
      var row = rows[rowId];
      if (!row || row.id !== rowId) errors.push('ROW_ID_MISMATCH_' + rowId);
      if (seen[rowId]) errors.push('ROW_DUPLICATE_' + rowId);
      seen[rowId] = true;
      if (!row || !row.br || !row.go) errors.push('ROW_BOOK_MISSING_' + rowId);
    });
    ['PB-051', 'PB-093', 'PB-099'].forEach(function (rowId) {
      if (!rows[rowId] || (rows[rowId].blocked !== true && !rows[rowId].approvedEstimateSku)) errors.push('BLOCKED_ROW_INVALID_' + rowId);
    });
    var expectedFnv = data.integrity && data.integrity.payloadFnv1a32;
    var actualFnv = fnv1a32(integrityPayload(data));
    if (!expectedFnv || expectedFnv !== actualFnv) errors.push('INTEGRITY_FNV_MISMATCH');
    if (data.transactionalApplicationAllowed !== false) errors.push('TRANSACTIONAL_GATE_OPEN');
    return { ok: errors.length === 0, errors: errors, rowCount: rowIds.length, actualFnv1a32: actualFnv };
  }

  function allProvidedTiersMatch(productTiers, rowBook) {
    var provided = 0;
    for (var i = 0; i < TIERS.length; i += 1) {
      var key = String(TIERS[i]);
      var productValue = normalizeStoredCents(productTiers[key]);
      if (productValue === null) continue;
      provided += 1;
      if (normalizeStoredCents(rowBook[key]) !== productValue) return false;
    }
    return provided > 0;
  }

  function resolution(status, reason, row, product) {
    return {
      status: status,
      reason: reason,
      row: row || null,
      rowId: row ? row.id : null,
      sku: product ? product.sku : null,
      safe: status === 'SAFE',
    };
  }

  function resolveProduct(data, rawPricing) {
    var product = normalizeProductPricing(rawPricing);
    var blockedPin = product.sku && data.pins && data.rowsById[data.pins[product.sku]];
    if (blockedPin && blockedPin.blocked) return resolution('BLOCKED', 'SOURCE_BLOCKED', blockedPin, product);
    if (!product.active) return resolution('UNMAPPED', 'PRICING_INACTIVE', null, product);
    if (blockedPin && blockedPin.approvedEstimateSku === product.sku && automationSafeRow(data, blockedPin)) return resolution('SAFE', 'AUTHORIZED_ESTIMATE_SKU', blockedPin, product);
    if (!completeProductSignature(product)) return resolution('REVIEW', 'COMPLETE_BR_SIGNATURE_REQUIRED', null, product);

    var row;
    var pinnedRowId = product.sku && data.pins ? data.pins[product.sku] : null;
    if (pinnedRowId) {
      row = data.rowsById[pinnedRowId];
      if (!row) return resolution('REVIEW', 'PIN_ROW_MISSING', null, product);
      if (!allProvidedTiersMatch(product.tiers, row.br)) return resolution('REVIEW', 'PIN_SIGNATURE_MISMATCH', row, product);
      if (row.blocked || (data.highAnomalyRows || []).indexOf(row.id) > -1) return resolution('BLOCKED', 'SOURCE_BLOCKED', row, product);
      if (!automationSafeRow(data, row)) return resolution('REVIEW', 'SOURCE_TIER_INCOMPLETE', row, product);
      return resolution('SAFE', 'PINNED_SKU_EXACT', row, product);
    }

    var signature = signatureFromBook(product.tiers);
    var candidateIds = data.signatureIndex && data.signatureIndex[signature] ? data.signatureIndex[signature] : [];
    if (candidateIds.length === 0) return resolution('UNMAPPED', 'SIGNATURE_NOT_FOUND', null, product);
    if (candidateIds.length > 1) return resolution('REVIEW', 'AMBIGUOUS_EXACT_SIGNATURE', null, product);
    row = data.rowsById[candidateIds[0]];
    if (!row) return resolution('REVIEW', 'SIGNATURE_ROW_MISSING', null, product);
    if (row.blocked || (data.highAnomalyRows || []).indexOf(row.id) > -1) return resolution('BLOCKED', 'SOURCE_BLOCKED', row, product);
    if (!automationSafeRow(data, row)) return resolution('REVIEW', 'SOURCE_TIER_INCOMPLETE', row, product);
    return resolution('SAFE', 'UNIQUE_EXACT_SIGNATURE', row, product);
  }

  function selectTier(quantity) {
    var value = Math.max(0, Number(quantity) || 0);
    if (value >= 10000) return 10000;
    if (value >= 5000) return 5000;
    if (value >= 2000) return 2000;
    return 1000;
  }

  function priceFor(row, region, quantity) {
    if (!row || row.blocked) return null;
    var normalizedRegion = region === 'GO' ? 'GO' : 'BR';
    var book = normalizedRegion === 'GO' ? row.go : row.br;
    var tier = selectTier(quantity);
    var perThousandCents = normalizeStoredCents(book && book[String(tier)]);
    if (perThousandCents === null) return null;
    var actualQuantity = Math.max(1, Number(quantity) || tier);
    return {
      region: normalizedRegion,
      tier: tier,
      quantity: actualQuantity,
      perThousandCents: perThousandCents,
      totalCents: Math.round(perThousandCents * actualQuantity / 1000),
      perUnitCents: perThousandCents / 1000,
    };
  }

  function shippingRule(data, region) {
    var normalizedRegion = region === 'GO' ? 'GO' : 'BR';
    if (!data || !data.commercial || !data.commercial[normalizedRegion]) return null;
    return data.commercial[normalizedRegion].freeShipping || null;
  }

  function qualifiesFreeShipping(data, region, totalCents) {
    var rule = shippingRule(data, region);
    if (!rule) return false;
    var total = Math.max(0, Number(totalCents) || 0);
    if (rule.mode === 'STRICTLY_ABOVE') return total > Number(rule.thresholdCents);
    if (rule.mode === 'AT_OR_ABOVE') return total >= Number(rule.thresholdCents);
    return false;
  }

  function amountUntilFreeShipping(data, region, totalCents) {
    var rule = shippingRule(data, region);
    if (!rule) return null;
    var total = Math.max(0, Number(totalCents) || 0);
    if (qualifiesFreeShipping(data, region, total)) return 0;
    return rule.mode === 'STRICTLY_ABOVE'
      ? Math.max(1, Number(rule.thresholdCents) - total + 1)
      : Math.max(0, Number(rule.thresholdCents) - total);
  }

  function safeAccessories(data, containerSku) {
    var sku = String(containerSku || '').trim().toUpperCase();
    var options = data && data.safeAccessoriesByContainer ? data.safeAccessoriesByContainer[sku] : null;
    return Array.isArray(options) ? options.filter(function (option) {
      var row = data.rowsById && data.rowsById[option.rowId];
      return automationSafeRow(data, row);
    }) : [];
  }

  return Object.freeze({
    TIERS: TIERS.slice(),
    toCents: toCents,
    normalizeMoneyToCents: normalizeMoneyToCents,
    normalizeStoredCents: normalizeStoredCents,
    normalizeProductPricing: normalizeProductPricing,
    signatureFromBook: signatureFromBook,
    completeBook: completeBook,
    completeProductSignature: completeProductSignature,
    automationSafeRow: automationSafeRow,
    integrityPayload: integrityPayload,
    fnv1a32: fnv1a32,
    validateData: validateData,
    resolveProduct: resolveProduct,
    selectTier: selectTier,
    priceFor: priceFor,
    shippingRule: shippingRule,
    qualifiesFreeShipping: qualifiesFreeShipping,
    amountUntilFreeShipping: amountUntilFreeShipping,
    safeAccessories: safeAccessories,
  });
});
// Desenvolvido por Clan Digital - https://clanmarketing.com.br/
